export const label = 'CONTENT.CONFIGURATION-FORM.TIME-MANAGEMENT.SCHEDULE.';

export const options = {
    dropdownDay: {
        data: [ { value: 1, label: label + 'MONDAY' },
                { value: 2, label: label + 'TUESDAY' },
                { value: 3, label: label + 'WEDNESDAY' },
                { value: 4, label: label + 'THURSDAY' },
                { value: 5, label: label + 'FRIDAY' },
                { value: 6, label: label + 'SATURDAY' },
                { value: 7, label: label + 'SUNDAY' } ],
        defaultValue: []
    },
    dropdownMonth: {
        data: [ { value: 1, label: label + 'JANUARY' },
                { value: 2, label: label + 'FEBRUARY' },
                { value: 3, label: label + 'MARCH' },
                { value: 4, label: label + 'APRIL' },
                { value: 5, label: label + 'MAY' },
                { value: 6, label: label + 'JUNE' },
                { value: 7, label: label + 'JULY' },
                { value: 8, label: label + 'AUGUST' },
                { value: 9, label: label + 'SEPTEMBER' },
                { value: 10, label: label + 'OCTOBER' },
                { value: 11, label: label + 'NOVEMBER' },
                { value: 12, label: label + 'DECEMBER' } ],
        defaultValue: []
    },
    dropdownDays: {
        data: [ { value: 1, label: '1' }, { value: 2, label: '2' },
                { value: 3, label: '3' }, { value: 4, label: '4' },
                { value: 5, label: '5' }, { value: 6, label: '6' },
                { value: 7, label: '7' }, { value: 8, label: '8' },
                { value: 9, label: '9' }, { value: 10, label: '10' },
                { value: 11, label: '11' }, { value: 12, label: '12' },
                { value: 13, label: '13' }, { value: 14, label: '14' },
                { value: 15, label: '15' }, { value: 16, label: '16' },
                { value: 17, label: '17' }, { value: 18, label: '18' },
                { value: 19, label: '19' }, { value: 20, label: '20' },
                { value: 21, label: '21' }, { value: 22, label: '22' },
                { value: 23, label: '23' }, { value: 24, label: '24' },
                { value: 25, label: '25' }, { value: 26, label: '26' },
                { value: 27, label: '27' }, { value: 28, label: '28' },
                { value: 29, label: '29' }, { value: 30, label: '30' },
                { value: 31, label: '31' },
        ],
        defaultValue: []
    },
    textInput: {
        checkValidation: (value) => {
            if(value < 0) { return false; }
            return true;
        },
        defaultValue: 1
    }
}